import HTTPStatus from 'http-status';
import {
    ESTACIO_VISUALITZACIO_OMPLIR_ESTACIONS,
    ESTACIO_VISUALITZACIO_OMPLIR_ESTACIONS_EN_CURS,
    ESTACIO_VISUALITZACIO_OMPLIR_ESTACIONS_FINALITZADA,
    ESTACIO_INICIALITZAR, ESTACIO_INTRODUCCIO_OMPLIR_ESTACIO_SELECCIONADA,
    ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_EN_CURS,
    ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_FINALITZADA,
    ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA,
    ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_I_DADES_EN_CURS,
    ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_I_DADES_FINALITZADA,
    ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES,
    ESTACIO_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS,
    ESTACIO_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA,
    ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS,
    ESTACIO_INTRODUCCIO_MOSTRAR_ERRORS,
    ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_NOM,
    ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_CODI,
    ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_DATA_ALTA,
    ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_TIPUS_ESTACIO,
    ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_CODI_AEMET,
    ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_OPERATIVA,
    ESTACIO_INTRODUCCIO_HISTORIC_OBSERVADORS_AFEGIR_OBSERVADOR,
    ESTACIO_INTRODUCCIO_HISTORIC_OBSERVADORS_ELIMINAR_OBSERVADOR,
    ESTACIO_INTRODUCCIO_HISTORIC_OBSERVADORS_MODIFICAR_OBSERVADOR,
    ESTACIO_INTRODUCCIO_FOTOS_CREAR_FOTO,
    ESTACIO_INTRODUCCIO_FOTOS_ELIMINAR_FOTO,
    ESTACIO_INTRODUCCIO_FOTOS_DESCARTAR_FOTO,
    ESTACIO_INTRODUCCIO_INCIDENCIES_AFEGIR_INCIDENCIA,
    ESTACIO_INTRODUCCIO_INCIDENCIES_ELIMINAR_INCIDENCIA,
    ESTACIO_INTRODUCCIO_INCIDENCIES_MODIFICAR_INCIDENCIA,
    ESTACIO_INTRODUCCIO_LOCALITZACIO_MODIFICAR_COORDENADES,
    ESTACIO_INTRODUCCIO_LOCALITZACIO_MODIFICAR_ALTITUD,
    ESTACIO_INTRODUCCIO_VARIABLES_MODIFICAR_VARIABLE_MOMENT,
    ESTACIO_INTRODUCCIO_METADADES_AFEGIR_METADADA,
    ESTACIO_INTRODUCCIO_METADADES_MODIFICAR_METADADA,
    ESTACIO_INTRODUCCIO_METADADES_ELIMINAR_METADADA,
    ESTACIO_DONAR_DE_BAIXA_EN_CURS,
    ESTACIO_DONAR_DE_BAIXA_FINALITZADA,
} from './actionTypes';

import { fetchEstacioIntroduccioEstructura,
    fetchEstacioIntroduccioEstructuraIDades,
    fetchEstacioIntroduccioCrearEstacio,
    fetchEstacioIntroduccioEditarEstacio,
    fetchObtenirEstacions,
    fetchDonarDeBaixaEstacio
} from '../commons/consultesServidor';
import { rutaEstacions } from '../routes/routeConstants';
import {
    selectorDadesBasiquesEditades,
    selectorLocalitzacioEditades,
    selectorVariablesMomentsEditades,
    selectorMetadadesEditades,
    selectorHistoricObservadorsEditades,
    selectorIncidenciesEditades,
    selectorFotosEliminades,
    selectorFotosCreades,
    selectorShanEliminatFotos,
    selectorShaModificatSeccioDadesBasiques,
    selectorShaModificatSeccioLocalitzacio,
    selectorShaModificatSeccioVariables,
    selectorShaModificatSeccioMetadades,
    selectorShaModificatSeccioHistoricObservadors,
    selectorShaModificatSeccioIncidencies,
    selectorErrorEnDadesObligatories
} from '../selectors/selector_estacio_formulari_dades';
import selectorIdEstacioSeleccionada from '../selectors/selector_estacio_formulari_id';
import {
    crearNotificacioSuccess,
    crearNotificacioWarning,
    crearNotificacioNoShanModificatValorsAlFormulari,
    crearNotificacioError
} from '../commons/notificacio';
import { usuariObtenirTots } from './usuari';

import { MASCARA_YYYYMMDD, MASCARA_DDMMYYYY } from '../commons/gestioDates';

import { errorConsultaServidor } from './error';

/**
 * Inicialitza tot l'estat referent al domini d'estacions.
 *
 * @returns {*}
 */
const estacioInicialitzar = () => {
    return {
        type: ESTACIO_INICIALITZAR
    };
};

/**
 * S'executa al entrar al component estacio.
 */
export const onEnterEstacio = () => {
    return (dispatch) => {
        dispatch(estacioInicialitzar());
        dispatch(usuariObtenirTots());
    };
};

/**
  * Obtenir l'estructura del formulari per crear una estació.
  *
  * @returns {Promise}
  */
export const estacioIntroduccioObtenirEstructura = (routerHistory) => {
    return (dispatch) => {
        dispatch(estacioIntroduccioObtenirEstructuraEnCurs());

        return fetchEstacioIntroduccioEstructura()
            .then((estructuraFormulariEstacio) => {
                dispatch(estacioIntroduccioOmplirEstructura(estructuraFormulariEstacio));
                dispatch(estacioIntroduccioObtenirEstructuraFinalitzada());
                routerHistory.push(rutaEstacions + '/introduccio');
            }, (errorServidor) => {
                dispatch(estacioIntroduccioObtenirEstructuraFinalitzada());
                const notificacioObtenirEstructuraFormulariEstacionsError = 'Error obtenint l\'estructura del formulari d\'estacions';
                dispatch(errorConsultaServidor(errorServidor, notificacioObtenirEstructuraFormulariEstacionsError));
            });
    };
};

/**
 * Indica que la petició per obtenir l'estructura del formulari
 * per crear una estació està en curs.
 *
 * @returns {Object}
 */
const estacioIntroduccioObtenirEstructuraEnCurs = () => {
    return {
        type: ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_EN_CURS
    };
};

/**
 * Indica que la petició per obtenir l'estructura del formulari
 * per crear una estació ha finalitzat.
 *
 * @returns {Object}
 */
const estacioIntroduccioObtenirEstructuraFinalitzada = () => {
    return {
        type: ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_FINALITZADA
    };
};

/**
 * Omple els reducers amb l'estructura del formulari per crear una estació.
 *
 * @param estructura {Object}
 * @returns {Object}
 */
const estacioIntroduccioOmplirEstructura = (estructura) => {
    return {
        type: ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA,
        estructura
    };
};

/**
  * Obtenir l'estructura del formulari i les dades per editar l'estació seleccionada.
  *
  * @param idEstacioSeleccionada {Integer}, routerHistory
  * @returns {Promise}
  */
export const estacioIntroduccioSeleccionarEstacio = (idEstacioSeleccionada, routerHistory) => {
    return (dispatch) => {
        dispatch(estacioIntroduccioObtenirEstructuraIDadesEnCurs());

        return fetchEstacioIntroduccioEstructuraIDades(idEstacioSeleccionada)
            .then((estructuraIDadesEstacio) => {
                dispatch(estacioIntroduccioOmplirEstacioSeleccionada(idEstacioSeleccionada));
                dispatch(estacioIntroduccioOmplirEstructuraIDades(estructuraIDadesEstacio));
                dispatch(estacioIntroduccioObtenirEstructuraIDadesFinalitzada());
                routerHistory.push(rutaEstacions + '/detall');
            }, (errorServidor) => {
                dispatch(estacioIntroduccioObtenirEstructuraIDadesFinalitzada());
                const notificacioObtenirEstructuraODadesFormulariEstacionsError = 'Error obtenint l\'estructura o les dades del formulari d\'estacions';
                dispatch(errorConsultaServidor(errorServidor, notificacioObtenirEstructuraODadesFormulariEstacionsError));
            });
    };
};

/**
 * Omple el reducer am l'identificador de l'estació seleccionada.
 * És l'estació de la qual es visualitzarà el detall.
 *
 * @param idEstacioSeleccionada {Integer}
 * @returns {Object}
 */
const estacioIntroduccioOmplirEstacioSeleccionada = (idEstacioSeleccionada) => {
    return {
        type: ESTACIO_INTRODUCCIO_OMPLIR_ESTACIO_SELECCIONADA,
        idEstacioSeleccionada
    };
};

/**
 * Indica que la petició per obtenir l'estructura del formulari i les dades
 * per editar una estació està en curs.
 *
 * @returns {Object}
 */
const estacioIntroduccioObtenirEstructuraIDadesEnCurs = () => {
    return {
        type: ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_I_DADES_EN_CURS
    };
};

/**
 * Indica que la petició per obtenir l'estructura del formulari i les dades
 * per editar una estació ha finalitzat.
 *
 * @returns {Object}
 */
const estacioIntroduccioObtenirEstructuraIDadesFinalitzada = () => {
    return {
        type: ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_I_DADES_FINALITZADA
    };
};

/**
 * Omple els reducers amb l'estructura del formulari i les dades de l'estació a editar.
 *
 * @param estructuraIDades {Object}
 * @returns {Object}
 */
const estacioIntroduccioOmplirEstructuraIDades = (estructuraIDades) => {
    return {
        type: ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES,
        estructuraIDades
    };
};

/**
 * Copia les dades "originals" a les "editades". S'utilitza quan es descarten els
 * canvis realitzats en el formulari d'edició d'una estació.
 *
 * @returns {String}
 */
export const estacioIntroduccioDescartarCanvis = () => {
    return {
        type: ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS
    };
};

/**
 * Informa d'una modificació en el nom de l'estació dins del formulari de crear/editar estació
 *
 * @param nom {String}
 * @returns {Object}
 */
export const estacioIntroduccioDadesBasiquesModificarNom = (nom) => {
    return {
        type: ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_NOM,
        nom
    };
};

/**
 * Informa d'una modificació en el codi de l'estació dins del formulari de crear/editar estació
 *
 * @param codi {String}
 * @returns {Object}
 */
export const estacioIntroduccioDadesBasiquesModificarCodi = (codi) => {
    return {
        type: ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_CODI,
        codi
    };
};

/**
 * Informa d'una modificació en la data d'alta de l'estació dins del formulari de crear/editar estació
 *
 * @param dataAlta {Moment}
 * @returns {Object}
 */
export const estacioIntroduccioDadesBasiquesModificarDataAlta = (dataAlta) => {
    const dataAltaText = dataAlta ? dataAlta.format(MASCARA_YYYYMMDD) : null;
    return {
        type: ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_DATA_ALTA,
        dataAlta: dataAltaText
    };
};

const convertirDatesATextDeUnHistoricObservador = (observador) => {

    if (!observador) return observador;

    const dataAlta = observador.dataAlta.format(MASCARA_YYYYMMDD);

    let dataBaixa = observador.dataBaixa;
    if (observador.dataBaixa) {
        dataBaixa = observador.dataBaixa.format(MASCARA_YYYYMMDD);
    }

    return {
        ...observador,
        dataAlta,
        dataBaixa
    };
};

/**
 * Afegeix un nou observador al estat.
 * @param {object} observador
 */
export const estacioIntroduccioAfegirObservadorHistoric = (observador) => {
    const observadorAmbDatesAText = convertirDatesATextDeUnHistoricObservador(observador);

    return {
        type: ESTACIO_INTRODUCCIO_HISTORIC_OBSERVADORS_AFEGIR_OBSERVADOR,
        observador: observadorAmbDatesAText
    };
};

/**
 * Modifica un observador al estat de redux. En principi només es pot modificar la
 * data d'alta i la data de baixa.
 * @param {number} indexObservador
 * @param {object} data pot tenir els atributs dataAlta o dataBaixa informats
 */
export const estacioIntroduccioModificarObservadorHistoric = (indexObservador, data) => {
    if (data.dataAlta) {
        data.dataAlta = data.dataAlta.format(MASCARA_YYYYMMDD);
    }

    if (data.dataBaixa) {
        data.dataBaixa = data.dataBaixa.format(MASCARA_YYYYMMDD);
    }

    return {
        type: ESTACIO_INTRODUCCIO_HISTORIC_OBSERVADORS_MODIFICAR_OBSERVADOR,
        indexObservador,
        data
    };
};

/**
 * Elimina un observador al estat.
 * @param {object} observador
 */
export const estacioIntroduccioEliminarObservadorHistoric = (indexObservadorAEliminar) => {
    return {
        type: ESTACIO_INTRODUCCIO_HISTORIC_OBSERVADORS_ELIMINAR_OBSERVADOR,
        indexObservador: indexObservadorAEliminar
    };
};

/**
 * Es contrueix l'objecte FormData amb les fotografies creades i les dades editades.
 *
 * @param fotosCreades {Array}, dades {Object}
 * @returns {Object}
 */
const obtenirFormData = (fotosCreades, dades) => {
    let dadesAEnviar = new FormData();
    fotosCreades.forEach(imatge => {
        dadesAEnviar.append('fotosCreades', imatge.fitxer);
    });
    dadesAEnviar.append('dades', JSON.stringify(dades));
    return dadesAEnviar;
};

/**
 * Es detecta si s'ha modificat el formulari.
 *
 * @param {Object} dadesModificadesFormulari
 * @param {Array} fotosCreades
 * @returns {Boolean}
 */
const noShanModificatDadesAlFormulari = (dadesModificadesFormulari, fotosCreades) => {
    const nombreDeSeccionsModificades = Object.keys(dadesModificadesFormulari).length;
    const nombreDeFotosCreades = fotosCreades.length;

    return nombreDeSeccionsModificades <= 0 && nombreDeFotosCreades <= 0;
};

/**
 * Contrueix l'estructura amb les dades que necessiten els endpoints per crear
 * o editar una estació a partir de l'estat de redux.
 *
 * @param estat {Object}
 * @returns {Object}
 */
const obtenirDadesAmbEstructuraAEnviar = (estat) => {

    // es mira si s'han modificat les seccions
    const shaModificatSeccioDadesBasiques = selectorShaModificatSeccioDadesBasiques(estat);
    const shaModificatSeccioLocalitzacio = selectorShaModificatSeccioLocalitzacio(estat);
    const shaModificatSeccioVariablesMoments = selectorShaModificatSeccioVariables(estat);
    const shaModificatSeccioMetadades = selectorShaModificatSeccioMetadades(estat);
    const shaModificatSeccioHistoricObservadors = selectorShaModificatSeccioHistoricObservadors(estat);
    const shaModificatSeccioIncidencies = selectorShaModificatSeccioIncidencies(estat);

    // s'insereixen les dades editades de les seccions amb modificacions
    let dadesEditades = {};
    if (shaModificatSeccioDadesBasiques) dadesEditades.dadesBasiques = selectorDadesBasiquesEditades(estat);
    if (shaModificatSeccioLocalitzacio) dadesEditades.localitzacio = selectorLocalitzacioEditades(estat);
    if (shaModificatSeccioVariablesMoments) dadesEditades.variablesMoments = selectorVariablesMomentsEditades(estat);
    if (shaModificatSeccioMetadades) dadesEditades.metadades = selectorMetadadesEditades(estat);
    if (shaModificatSeccioHistoricObservadors) dadesEditades.historicObservadors = selectorHistoricObservadorsEditades(estat);
    if (shaModificatSeccioIncidencies) dadesEditades.incidencies = selectorIncidenciesEditades(estat);

    return dadesEditades;
};

// TODO: moure a arxiu commons (per exemple consultesServidor i unificar a l'action creator avis.avisFormulariEnviar)
/**
 * Quan el servidor retorna que la petició s'ha executat correctament, es tracten
 * els possibles casos d'estat d'aquesta: OK, PARTIAL_CONTENT i ERROR.
 * En el nostre cas s'ha usta el PARTIAL_CONTENT en el cas de les fotografies.
 *
 * @param resposta {Object}, configuracioNotificacions {Object}
 * @returns {*}
 */
const mostrarNotificacioAPartirDeRespostaServidor = (resposta, configuracioNotificacions) => {
    switch (resposta.status) {
        case HTTPStatus.OK: {
            crearNotificacioSuccess(configuracioNotificacions.exit);
            break;
        }
        case HTTPStatus.PARTIAL_CONTENT: {
            crearNotificacioWarning(configuracioNotificacions.advertencia.titol,
                configuracioNotificacions.advertencia.descripcio);
            break;
        }
        default: {
            console.warn(`Error de tipus ${resposta.status}: ${resposta.body}`);
            crearNotificacioError(configuracioNotificacions.error);
        }
    }
};

/**
 * Enviar les dades per crear o editar una estació.
 *
 * @returns {Promise}
 */
export const estacioIntroduccioEnviarFormulari = (routerHistory) => {
    return (dispatch, getState) => {

        const estat = getState();

        if (selectorErrorEnDadesObligatories(estat)) {
            dispatch(estacioIntroduccioMostrarErrors());
            const notificacioErrorDadesObligatoriesAdvertencia = 'El formulari conté errors en dades obligatòries';
            crearNotificacioWarning(notificacioErrorDadesObligatoriesAdvertencia);
            return;
        }

        const idEstacioSeleccionada = selectorIdEstacioSeleccionada(estat);
        const fotosCreades = selectorFotosCreades(estat);
        const nomEstacio = selectorDadesBasiquesEditades(estat).nom || '';

        // s'obté l'estructura amb les dades editades de les seccions amb modificacions sense les fotos eliminades
        let dadesEditades = obtenirDadesAmbEstructuraAEnviar(estat);

        let promesa;
        let configuracioNotificacions;
        let rutaRedireccionamentSiInsercioOk;

        if (idEstacioSeleccionada !== null) { // editant estació
            const shanEliminatFotos = selectorShanEliminatFotos(estat);
            if (shanEliminatFotos) dadesEditades.fotosEliminades = selectorFotosEliminades(estat);

            if (noShanModificatDadesAlFormulari(dadesEditades, fotosCreades)) {
                crearNotificacioNoShanModificatValorsAlFormulari();
                return;
            }

            const dadesAEnviar = obtenirFormData(fotosCreades, dadesEditades);
            dispatch(estacioIntroduccioEnviarFormulariEnCurs());
            promesa = fetchEstacioIntroduccioEditarEstacio(idEstacioSeleccionada, dadesAEnviar);

            const notificacioEditarEstacioExit = `Estació "${nomEstacio}" editada correctament`;
            const notificacioEditarEstacioAdvertencia = {
                titol: notificacioEditarEstacioExit,
                descripcio: 'Les fotos no s\'han pogut modificar.'
            };
            const notificacioEditarEstacioError = 'Error editant l\'estació';

            configuracioNotificacions = {
                exit: notificacioEditarEstacioExit,
                advertencia: notificacioEditarEstacioAdvertencia,
                error: notificacioEditarEstacioError
            };

            rutaRedireccionamentSiInsercioOk = rutaEstacions;

        } else { // creant estació

            if (noShanModificatDadesAlFormulari(dadesEditades, fotosCreades)) {
                crearNotificacioNoShanModificatValorsAlFormulari();
                return;
            }

            const dadesAEnviar = obtenirFormData(fotosCreades, dadesEditades);
            dispatch(estacioIntroduccioEnviarFormulariEnCurs());
            promesa = fetchEstacioIntroduccioCrearEstacio(dadesAEnviar);

            const notificacioCrearEstacioExit = 'Estació creada correctament';
            const notificacioCrearEstacioAdvertencia = {
                titol: notificacioCrearEstacioExit,
                descripcio: 'Les fotos no s\'han pogut inserir.'
            };
            const notificacioCrearEstacioError = 'Error creant l\'estació';

            configuracioNotificacions = {
                exit: notificacioCrearEstacioExit,
                advertencia: notificacioCrearEstacioAdvertencia,
                error: notificacioCrearEstacioError
            };

            rutaRedireccionamentSiInsercioOk = rutaEstacions;
        }

        return promesa
            .then((resposta) => {
                dispatch(estacioIntroduccioEnviarFormulariFinalitzada());
                mostrarNotificacioAPartirDeRespostaServidor(resposta, configuracioNotificacions);
                routerHistory.push(rutaRedireccionamentSiInsercioOk);
            }, (errorServidor) => {
                dispatch(estacioIntroduccioEnviarFormulariFinalitzada());
                dispatch(errorConsultaServidor(errorServidor, configuracioNotificacions.error));
            });
    };
};

/**
 * Indica que la petició per inserir les dades per crear o editar
 * una estació està en curs.
 *
 * @returns {Object}
 */
const estacioIntroduccioEnviarFormulariEnCurs = () => {
    return {
        type: ESTACIO_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS
    };
};

/**
 * Indica que la petició per inserir les dades per crear o editar
 * una estació ha finalitzat.
 *
 * @returns {Object}
 */
const estacioIntroduccioEnviarFormulariFinalitzada = () => {
    return {
        type: ESTACIO_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA
    };
};

/**
 * Indica que s'han de mostrar errors de dades inserides al formulari
 * de creació/edició d'una estació
 *
 * @returns {Object}
 */
const estacioIntroduccioMostrarErrors = () => {
    return {
        type: ESTACIO_INTRODUCCIO_MOSTRAR_ERRORS
    };
};

/**
 * S'informa que la petició al servidor per obtenir les estacions s'ha iniciat
 * i està en curs.
 *
 * @returns {{type}|*}
 */
const peticioEstacioVisualitzacioObtenirEstacionsEnCurs = () => {
    return {
        type: ESTACIO_VISUALITZACIO_OMPLIR_ESTACIONS_EN_CURS
    };
};

/**
 * S'informa que la petició al servidor per obtenir les estacions, ha finalitzat
 * ja sigui correctament o amb error.
 *
 * @returns {{type}|*}
 */
const peticioEstacioVisualitzacioObtenirEstacionsFinalitzada = () => {
    return {
        type: ESTACIO_VISUALITZACIO_OMPLIR_ESTACIONS_FINALITZADA
    };
};

/**
 * S'informa de la modificació de la llista d'estacions.
 * @param periode {Array} Estacions
 * @returns {{type, estacions}|*}
 */
const estacioVisualitzacioOmplirEstacions = (estacions) => {
    return {
        type: ESTACIO_VISUALITZACIO_OMPLIR_ESTACIONS,
        estacions
    };
};

/**
 * Consulta per recuperar les estacions
 * @returns {*}
 */
export const estacioVisualitzacioObtenirEstacions = () => {
    return dispatch => {
        dispatch(peticioEstacioVisualitzacioObtenirEstacionsEnCurs());

        return fetchObtenirEstacions().then(
            estacions => {
                dispatch(estacioVisualitzacioOmplirEstacions(estacions));
                dispatch(peticioEstacioVisualitzacioObtenirEstacionsFinalitzada());
            },
            errorServidor => {
                dispatch(peticioEstacioVisualitzacioObtenirEstacionsFinalitzada());
                const notificacioObtenirEstacionsError = 'Error obtenint les estacions.';
                dispatch(errorConsultaServidor(errorServidor, notificacioObtenirEstacionsError));
            }
        );
    };
};

/**
 * S'afegeix una foto al llistat de fotos creades
 * @param foto {Object}
 * @returns {{type, foto}|*}
 */
export const estacioIntroduccioFotosCrearFoto = (foto) => {
    return {
        type: ESTACIO_INTRODUCCIO_FOTOS_CREAR_FOTO,
        foto
    };
};

/**
 * S'afegeix una foto al llistat de fotos eliminades
 * @param foto {Object}
 * @returns {{type, foto}|*}
 */
export const estacioIntroduccioFotosEliminarFoto = (foto) => {
    return {
        type: ESTACIO_INTRODUCCIO_FOTOS_ELIMINAR_FOTO,
        foto
    };
};

/**
 * S'elimina la foto amb l'índex especificat del llistat de fotos creades
 * @param indexFoto {Object}
 * @returns {{type, indexFoto}|*}
 */
export const estacioIntroduccioFotosDescartarFoto = (indexFoto) => {
    return {
        type: ESTACIO_INTRODUCCIO_FOTOS_DESCARTAR_FOTO,
        indexFoto
    };
};

/**
 * Afegeix una nova incidencia. Abans de fer el return converteix les dataInici i dataFi de String a moment.
 * @param {Object} incidencia
 */
export const estacioIntroduccioIncidenciesAfegirIncidencia = (incidencia) => {
    const incidenciaAmbDadesText = {
        ...incidencia,
        dataInici: incidencia.dataInici.format(MASCARA_YYYYMMDD),
        dataFi: (incidencia.dataFi) ? incidencia.dataFi.format(MASCARA_YYYYMMDD) : undefined
    };

    return {
        type: ESTACIO_INTRODUCCIO_INCIDENCIES_AFEGIR_INCIDENCIA,
        incidencia: incidenciaAmbDadesText
    };
};

/**
 * Accio per esborrar la incidencia que estroba la index especificat per parametre.
 * @param {number} indexIncidenciaAEliminar
 */
export const estacioIntroduccioIncidenciesEliminarIncidencia = (indexIncidenciaAEliminar) => ({
    type: ESTACIO_INTRODUCCIO_INCIDENCIES_ELIMINAR_INCIDENCIA,
    indexIncidencia: indexIncidenciaAEliminar

});

/**
 *
 * @param {number} index
 * @param {object} dadaModificada
 */
export const estacioIntroduccioIncidenciesModificarIncidencia = (indexIncidencia, dadaModificada) => {

    if (dadaModificada.dataInici) {
        dadaModificada.dataInici = dadaModificada.dataInici.format(MASCARA_YYYYMMDD);
    }

    if (dadaModificada.dataFi) {
        dadaModificada.dataFi = dadaModificada.dataFi.format(MASCARA_YYYYMMDD);
    }

    return {
        type: ESTACIO_INTRODUCCIO_INCIDENCIES_MODIFICAR_INCIDENCIA,
        dadaModificada,
        indexIncidencia: indexIncidencia
    };

};

/*
 * Informa d'una modificació en les coordenades (latitud o longitud) de l'estació dins del formulari de crear/editar estació
 *
 * @param coordenades {Object}
 * @returns {Object}
 */
export const estacioIntroduccioLocalitzacioModificarCoordenades = (coordenades) => {
    return {
        type: ESTACIO_INTRODUCCIO_LOCALITZACIO_MODIFICAR_COORDENADES,
        coordenades
    };
};

/**
 * Informa d'una modificació en l'altitud de l'estació dins del formulari de crear/editar estació
 *
 * @param altitud {Number}
 * @returns {Object}
 */
export const estacioIntroduccioLocalitzacioModificarAltitud = (altitud) => {
    return {
        type: ESTACIO_INTRODUCCIO_LOCALITZACIO_MODIFICAR_ALTITUD,
        altitud
    };
};

/**
 * Informa d'una modificació en el tipus de l'estació dins del formulari de crear/editar estació
 *
 * @param idTipusEstacio {Number}
 * @returns {Object}
 */
export const estacioIntroduccioDadesBasiquesModificarTipusEstacio = (idTipusEstacio) => {
    return {
        type: ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_TIPUS_ESTACIO,
        idTipusEstacio
    };
};

/**
 * Informa d'una modificació en el codi d'AEMET dins del formulari de crear/editar estació
 *
 * @param codiAEMET {String}
 * @returns {Object}
 */
export const estacioIntroduccioDadesBasiquesModificarCodiAEMET = (codiAEMET) => {
    return {
        type: ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_CODI_AEMET,
        codiAEMET
    };
};

/**
 * Informa d'una modificació en la check d'operativa dins del formulari de crear/editar estació
 *
 * @param operativa {Boolean}
 * @returns {Object}
 */
export const estacioIntroduccioDadesBasiquesModificarOperativa = (operativa) => {
    return {
        type: ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_OPERATIVA,
        operativa
    };
};

/**
 * Informa d'una modificació en les variablesMoments actives de l'estació
 *
 * @param {Boolean} estaVariableMomentActiva
 * @returns {Object}
 */
export const estacioIntroduccioVariablesModificarVariableMoment = (idVariableMoment, estaVariableMomentActiva) => {
    return {
        type: ESTACIO_INTRODUCCIO_VARIABLES_MODIFICAR_VARIABLE_MOMENT,
        idVariableMoment,
        estaVariableMomentActiva
    };
};

/**
 * Afegeix una nova metadada a l'estat.
 * @param {object} idMetadada
 */
export const estacioIntroduccioAfegirMetadada = (idMetadada) => {
    return {
        type: ESTACIO_INTRODUCCIO_METADADES_AFEGIR_METADADA,
        idMetadada
    };
};

/**
 * Modifica una metadada a l'estat.
 * @param {number} idMetadada
 * @param {number} idCamp
 * @param {object} valors
 */
export const estacioIntroduccioModificarMetadada = (idMetadada, idCamp, valors) => {
    return {
        type: ESTACIO_INTRODUCCIO_METADADES_MODIFICAR_METADADA,
        idMetadada,
        idCamp,
        valors
    };
};

/**
 * Elimina una metadada a l'estat.
 * @param {number} idMetadada
 */
export const estacioIntroduccioEliminarMetadada = (idMetadada) => {
    return {
        type: ESTACIO_INTRODUCCIO_METADADES_ELIMINAR_METADADA,
        idMetadada
    };
};

const estacioDonarDeBaixaEnCurs = () => ({type: ESTACIO_DONAR_DE_BAIXA_EN_CURS});
const estacioDonarDeBaixaFinalitzada = () => ({type: ESTACIO_DONAR_DE_BAIXA_FINALITZADA});

/**
 * Fa la petició per a donar de baixa una estació
 * @param {Integer} idEstacio
 * @param {String} nomEstacio
 * @param {Moment} dataBaixa
 * @param {Object} routerHistory
 */
export const estacioDonarDeBaixaEstacio = (idEstacio, nomEstacio, dataBaixa, routerHistory) => {

    return (dispatch) => {

        dispatch(estacioDonarDeBaixaEnCurs());

        return fetchDonarDeBaixaEstacio(idEstacio, dataBaixa).then(
            () => {
                const dataBaixaText = dataBaixa.format(MASCARA_DDMMYYYY);
                dispatch(estacioDonarDeBaixaFinalitzada());
                routerHistory.push(rutaEstacions);

                const notificacioEliminarEstacioExit = {
                    titol: 'Estació donada de baixa correctament',
                    descripcio: `L'estació "${nomEstacio}" amb data ${dataBaixaText}.`
                };
                crearNotificacioSuccess(notificacioEliminarEstacioExit.titol,
                    notificacioEliminarEstacioExit.descripcio);
            },
            errorServidor => {
                dispatch(estacioDonarDeBaixaFinalitzada());
                const notificacioEliminarEstacioError = 'Error donant de baixa l\'estació';
                dispatch(errorConsultaServidor(errorServidor, notificacioEliminarEstacioError));
            }
        );
    };
};



// WEBPACK FOOTER //
// ./src/actions/estacio.js